import React from "react";
import { Divider, Link, makeStyles, Paper } from "@material-ui/core";
import { News } from "../domain/News";
import {
  formatUtcDate,
  standardDateFormats,
} from "@ofqual/portal-core/core/utils/dateUtils";
import ReactMarkdown from "react-markdown";
import { Link as RouterLink } from "react-router-dom";
import { getLogo } from "./logoHelper";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: "100px",
    padding: 20,
    marginBottom: 30,
    minHeight: 100,
    ...theme.list.itemPrimary,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  logoContainer: {
    height: 30,
    float: "right",
  },
  content: {
    minHeight: 40,
  },
  footer: {
    textAlign: "right",
    marginTop: 5,
  },
}));

type NewsListItemProps = {
  newsItem: News;
};

export const NewsListItem: React.FC<NewsListItemProps> = ({ newsItem }) => {
  const classes = useStyles();

  return (
    <Link
      to={`articles/${newsItem.id}`}
      component={RouterLink}
      underline="none"
    >
      <Paper className={classes.root} square>
        <div className={classes.logoContainer}>{getLogo(newsItem.type)}</div>

        <h3>{newsItem.title}</h3>
        <div className={classes.content}>
          {newsItem.subHeading}
          <ReactMarkdown>{newsItem.excerpt}</ReactMarkdown>
        </div>
        <Divider />
        <div className={classes.footer}>
          {formatUtcDate(newsItem.publishedDate, standardDateFormats.FULL_DATE_TIME) !==
          formatUtcDate(newsItem.modifiedDate, standardDateFormats.FULL_DATE_TIME) ? (
            <>
              {" "}
              <b>Updated on</b>{" "}
              <span style={{ marginRight: 10 }}>
                {formatUtcDate(
                  newsItem.modifiedDate,
                  standardDateFormats.FULL_DATE_TIME
                )}
              </span>
            </>
          ) : null}
          <b>Published on</b>{" "}
          {formatUtcDate(
            newsItem.publishedDate,
            standardDateFormats.FULL_DATE_TIME
          )}
        </div>
      </Paper>
    </Link>
  );
};
